import { createStore } from 'vuex';
import { getAuth } from 'firebase/auth';
import { collection, doc, getDoc } from 'firebase/firestore';
import { db } from '@/main';

export default createStore({
  state: {
    showDialog: false,
    photo: null, // Photo Itilizatè
  },
  mutations: {
    setShowDialog(state, value) {
      state.showDialog = value;
    },
    setPhoto(state, photoURL) {
      state.photo = photoURL; // Met à jour la photo Itilizatè
    },
  },
  actions: {
    triggerDialog({ commit }) {
      commit('setShowDialog', true);
    },
    async loadUserPhoto({ commit }) {
      try {
       
        // Sinon, récupérez depuis Firestore
        const auth = getAuth();
        const user = auth.currentUser;
        if (user) {
          const userDocRef = doc(collection(db, 'users'), user.uid);
          const userDoc = await getDoc(userDocRef);

          if (userDoc.exists()) {
            const userData = userDoc.data();
            if (userData && userData.photoURL) {
              commit('setPhoto', userData.photoURL);
            }
          }
        }
      } catch (error) {
        console.error('Erreur lors du chargement de la photo Itilizatè :', error);
      }
    },
  },
  getters: {
    photo: (state) => state.photo, // Getter pour accéder à la photo
  },
  modules: {},
});
